import React from 'react';

import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

import { MultilineTextField } from './styles';

const QueryStringSection = ({ query, loading }) => (
  <Container>
    <StyledTypography variant="body2" color="#999">
      Query String
    </StyledTypography>
    <MultilineTextField
      multiline
      disabled
      loading={loading}
      value={loading ? 'Loading...' : query}
      variant="outlined"
      rows={4}
    />
  </Container>
);

const Container = styled.div`
  background: white;
`;

export default QueryStringSection;
